<template>

<div class="main list-view report-list-wrapper">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<label>{{ searchTip }}</label>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>

		<div class="divider"></div>

		<select v-model="filters.department_id" @change="getList()">
			<option value="">Department...</option>
			<option v-for="(item, index) in departments" :value="item.department_id">{{ item.description }}</option>
		</select>
		<select v-model="filters.manufacturer_id" @change="getList()">
			<option value="">Manufacturer...</option>
			<option v-for="(item, index) in manufacturers" :value="item.manufacturer_id">{{ item.description }}</option>
		</select>
		<select v-model="filters.supplier_id" @change="getList()">
			<option value="">Supplier...</option>
			<option v-for="(item, index) in suppliers" :value="item.supplier_id">{{ item.full_name }}</option>
		</select>

		<div class="divider"></div>

		<div v-if="filters.product_id">
			<div class="button neutral" @click="filters.product_id = ''">Back To List</div>
		</div>
		<div v-else>
			<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
			<div class="divider"></div>
			<div :class="['extra-menu-item', gettingExport ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		</div>

	</div>

	<div v-if="filters.product_id" class="detail">

		<div class="detail-sub-header">
			<div class="detail-title" v-html="productDetail.description"></div>
		</div>

		<div style="float: right; width: 75%; padding: 0 2em 0 1em; border-left: 1px solid #ccc; height: 380px; overflow-y: scroll; text-align: left;">
			<table class="data-list" style="width: 100%; line-height: 1.5em;" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list">Date</th>
						<th class="list">Supplier</th>
						<th class="list">PO #</th>
						<th class="list">Invoice #</th>
						<th class="list right">Cost</th>
						<th class="list right">Received</th>
						<th class="list right">Ext Cost</th>
					</tr>
				</thead>
				<tr v-for="history in productHistory">
					<td class="list">{{ $moment(history.received_date).format('MM/DD/YYYY') }}</td>
					<td class="list">{{ history.company_name }}</td>
					<td class="list">{{ history.purchase_order_number }}</td>
					<td class="list">{{ history.invoice_number }}</td>
					<td class="list right">{{ history.cost }}</td>
					<td class="list right">{{ history.quantity_received }}</td>
					<td class="list right">{{ (history.quantity_received * history.cost).toFixed(2) }}</td>
				</tr>
			</table>
		</div>

		<div class="one-two-columns" style="line-height: 1.5em;">
			<label>UPC</label><div>{{ productDetail.upc }}</div>
			<label>SKU</label><div>{{ productDetail.sku }}</div>
			<label>Model</label><div>{{ productDetail.model }}</div>
			<label>Department</label><div>{{ productDetail.department }}</div>
			<label>Category</label><div>{{ productDetail.category }}</div>
			<label>Manufacturer</label><div>{{ productDetail.manufacturer }}</div>
			<label>Caliber</label><div>{{ productDetail.caliber }}</div>
			<label>MSRP</label><div>{{ productDetail.msrp }}</div>
			<label>MAP</label><div>{{ productDetail.map }}</div>
		</div>

	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date</th>
					<th class="list left">UPC</th>
					<th class="list left">Description</th>
					<th class="list right">Cost</th>
					<th class="list right">Price</th>
					<th class="list right">Received</th>
					<th class="list right">Ext Cost</th>
					<th class="list right">Ext Price</th>
				</tr>
			</thead>
			<tr v-for="item in list" :class="item.is_list_item ? 'clickable-list-item' : 'list_row_totals'" @click="getItem(item)">
				<td class="list left">{{ $moment(item.received_date).format('MM/DD/YYYY') }}</td>
				<td class="list left">{{ item.upc }}</td>
				<td class="list left">{{ item.description }}</td>
				<td class="list right">{{ item.cost }}</td>
				<td class="list right">{{ item.price }}</td>
				<td class="list right">{{ item.received }}</td>
				<td class="list right">{{ item.ext_cost }}</td>
				<td class="list right">{{ item.ext_price }}</td>
			</tr>
		</table>

	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{236:'Inventory Received Report'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'report-list',
    components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: true,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			searchTip: 'Search for a product by UPC or description.',
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
            default_start_date: '',
            default_end_date: '',
			filterMessage: '',
			filterLoading: false,
			definition: [],
			list: [],
			freight: '',
			paging: {},
			departments: [],
			manufacturers: [],
			suppliers: [],
			showDetail: false,
			productName: '',
			productDetail: {},
			productHistory: [],
			exportMessage: '',
			gettingExport: false
		}
	},
	created() {
		this.getFilterLists()
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: '',
				department_id: '',
				manufacturer_id: '',
				supplier_id: '',
				product_id: '',
				do_export: false
			}

			var oneMonthAgo = new Date()
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.default_start_date = oneMonthAgo.toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)
			this.filters.start_date = this.default_start_date
			this.filters.end_date = this.default_end_date
			if (getList) {
				this.getList()
			}
		},
		getList() {
			this.productId = ''
			this.loading = true
			this.message = 'Generating report...'
			this.apiCall({ destination: 'get_list_inventory_received', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					// accommodate live server filecache latency
					setTimeout(() => {
						this.message = 'Downloading CSV...'
						document.getElementById("download").src = obj.download_url
						this.gettingExport = false
						this.exportMessage = ''
						setTimeout(() => {
							this.message = ''
							this.messageStatus = ''
						}, 2000)
					}, 500)
				} else {
					this.list = obj.list
					this.freight = obj.freight
					this.message = ''
					if (this.filters.start_date != this.default_start_date || this.filters.end_date != this.default_end_date) {
						this.getFilterLists()
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getFilterLists() {
			this.apiCall({ destination: 'get_filter_lists_inventory_received', data: this.filters }).then(obj => {
				this.departments = obj.departments
				this.manufacturers = obj.manufacturers
				this.suppliers = obj.suppliers
			}).catch(err => {
				console.log(err)
			})
		},
		getItem(item) {
			if (this.loading || !item.is_list_item) { return }
			this.loading = true
			this.filters.product_id = item.product_id
			this.apiCall({ destination: 'get_item_inventory_received', data: this.filters }).then(obj => {
				this.loading = false
				this.productDetail = obj.product_detail
				this.productHistory = obj.product_history
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList(1)
		}
	}
}
</script>
